import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure your project is capable of handling css files

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: '#354366',
        secondary: '#D76C12',
        terciary: '#34405f',
        quaternary: '#546BA5',
        info: '#2E5172',
      },
      light: {
        primary: '#354366',
        secondary: '#D76C12',
        terciary: '#34405f',
        quaternary: '#546BA5',
        info: '#2E5172',
      },
    },
  },
})
